export default {"src":"__ASTRO_ASSET_IMAGE__6620a82b__","width":105,"height":25,"format":"svg"}